/**
 * servicing eapi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface TravelerRegulatoryDetailsVisasInner {
  /**
   * VISA情報のID
   */
  id?: string;
  /**
   * visa番号
   */
  number?: string;
  /**
   * 発行国
   */
  issuanceCountryCode?: string;
  /**
   * 有効期限
   */
  expiryDate?: string;
  /**
   * 無期限かどうか。有効期限が1999/12/31の場合、trueを返却
   */
  isNoExpiration?: boolean;
  /**
   * visa登録状態<br/> completed：visa番号、発行国、有効期限がすべて登録されている<br/> partial：visa番号、発行国、有効期限の内一部が未登録
   */
  registeredStatus?: TravelerRegulatoryDetailsVisasInner.RegisteredStatusEnum;
  /**
   * 重複VISAIDリスト<br/> VISA情報が複数存在し、VISA情報の内容を比較した結果、同一の内容と判定された場合、そのVISA情報のVISA情報IDを返却する。<br/> ※返却対象の抽出は重複パスポートIDリスト項目と同様とする。
   */
  deduplicatedVisaIds?: Array<string>;
}
export namespace TravelerRegulatoryDetailsVisasInner {
  export type RegisteredStatusEnum = 'completed' | 'partial';
  export const RegisteredStatusEnum = {
    Completed: 'completed' as RegisteredStatusEnum,
    Partial: 'partial' as RegisteredStatusEnum,
  };
}
